import { func, object, string } from 'prop-types';
import React from 'react';

import { button } from './Canvas.less';

const Canvas = ({ draw, ...props }, { fm }) => {
  const canvasRef = React.useRef(null);
  const linkRef = React.useRef(null);

  // Set timeout from mount to rerender the canvas once
  // Bit of a hack, but fixes the canvas not updating by itself
  React.useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    setTimeout(() => draw(context), 300);
  }, []);

  // Render the canvas every time the draw function changes
  React.useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    draw(context);
  }, [draw]);

  linkRef.current && linkRef.current.setAttribute('download', 'Huoneentaulu.png');
  linkRef.current &&
    canvasRef.current &&
    linkRef.current.setAttribute(
      'href',
      canvasRef.current.toDataURL('image/png').replace('image/png', 'image/octet-stream'),
    );
  return (
    <div>
      <canvas ref={canvasRef} {...props} />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2rem' }}>
        <div className={button}>
          <a ref={linkRef}>
            {'>'} &nbsp;
            {fm('onlineRehabilitation.downloadPicture')}
          </a>
        </div>
      </div>
    </div>
  );
};

Canvas.contextTypes = {
  fm: func,
};
Canvas.propTypes = {
  draw: func,
  width: string,
  height: string,
  style: object,
};

export default Canvas;
